export const MuiButton = {
  root: {
    'padding': '12px 40px',
    'white-space': 'nowrap',
    'fontFamily': 'knowledge2017medium',
    'fontSize': '16px',
    'lineHeight': '20px',
    'text-transform': 'uppercase',
    'letterSpacing': '0.5px',
    'margin': 0,
  },
  sizeLarge: {
    padding: '40px',
  },
  sizeSmall: {
    padding: '8px 8px',
    fontSize: '14px',
    lineHeight: '16px',
  },
  text: {
    padding: 'inherits',
  },
  outlined: {
    padding: 'inherits',
  },
}
